// E:\SAUDIDUNES11\frontend\src\components\StockDisclaimer.jsx
import { useState, useEffect } from "react";
import styled from "styled-components";

const Box = styled.div`
  position: sticky;
  left: 0;
  width: 100%;
  max-width: 1100px;
  box-sizing: border-box;
  margin: 20px 0; /* ← changed from "20px auto" */
  padding: 12px 16px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-left: 4px solid #ffb300;
  border-radius: 6px;
  font-size: 13px;
  color: #5d4037;
  line-height: 1.5;
  z-index: 10;

  @media only screen and (max-width: 768px) {
    margin: 10px 0;
    padding: 10px 12px;
    font-size: 12px;
  }
`;

const Title = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
  color: #e65100;
`;

const AgreeLink = styled.span`
  color: #e65100;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 6px;
  font-weight: 600;

  &:hover {
    color: #bf360c;
  }
`;

export default function StockDisclaimer() {
  // Start hidden to avoid a flash on reload; useEffect decides the real state
  // after reading localStorage.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const agreed = localStorage.getItem("stockDisclaimerAgreed");
    if (!agreed) setVisible(true);
  }, []);

  const handleAgree = () => {
    localStorage.setItem("stockDisclaimerAgreed", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box>
      <Title>⚠️ Disclaimer</Title>
      Data shown on this page is for{" "}
      <strong>informational and educational purposes only</strong>. This is{" "}
      <strong>not investment advice</strong> and should not be used for trading
      decisions.
      <AgreeLink onClick={handleAgree}>I agree — hide this</AgreeLink>
    </Box>
  );
}
